<template lang="pug">
div
  h3.form-title.text-center ยืนยันข้อมูลการสมัคร
  .results
    step1
    Step2
    Step3
    Step4
  footer.form-footer
    .d-flex.justify-content-center
      button.back(@click='$store.commit("SET_STEP", 4)') กลับสู่ก่อนหน้า
      button.finish(@click='submit') ยืนยันการสมัครงาน
</template>
<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Step1 from '../components/step5/Step1.vue'
import Step2 from '../components/step5/Step2.vue'
import Step3 from '../components/step5/Step3.vue'
import Step4 from '../components/step5/Step4.vue'
export default {
  components: { Step1, Step2, Step3, Step4 },
  computed: {
    ...mapState(['personalData', 'education', 'employmentRecord', 'skills']),
  },

  methods: {
    submit() {
      axios
        .post(`${THAIRUNG.api_endpoint}v1/job/register`, {
          personalData: this.personalData,
          education: this.education,
          employmentRecord: this.employmentRecord,
          skills: this.skills,
        })
        .then(({ data }) => {
          this.$store.commit('SET_STEP', 1)
          this.$store.commit('SET_PERSONAL_DATA', {})

          this.$fire({
            title: 'ส่งข้อมูลเรียร้อย',
            text: 'ส่งข้อมูลเรียร้อย ทางทีมงานจะรีบติดต่อไปค่ะ',
            type: 'success',
          }).then((r) => {})
        })
        .catch((error) => {})
        .then(() => {
          this.isLoading = false
        })
    },
  },
}
</script>

<style lang="scss">
.result {
  padding: 2rem;
  background: #f5fbfe;

  &:not(:last-child) {
    border-bottom: solid 1px #e8e8e8;
  }

  &-item {
    font-size: 18px;
    padding: 0.5rem 0;

    strong {
      white-space: nowrap;
      color: #58595b;
    }

    span {
      color: #19499c;
    }
  }

  &-title {
    margin-bottom: 2rem;
  }
}
</style>